var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pin-card",class:{single: !_vm.title}},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"p-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-sub"},[_vm._v(_vm._s(_vm.sub))])])
}
var staticRenderFns = []

export { render, staticRenderFns }